var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalNoteBadgeMemo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 3.75,
    width: 8.25,
    height: 10,
    rx: 1,
    fill: "#fff",
    stroke: "#c9bfb0",
    strokeWidth: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#d8cfc2",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    d: "M3.6 6.4h4.8M3.6 8.3h4.8M3.6 10.2h3.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.2 12.5) rotate(-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -6.2,
    width: 2,
    height: 1.4,
    rx: 0.28,
    fill: "#f472b0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.85,
    y: -4.9,
    width: 1.7,
    height: 6.5,
    rx: 0.38,
    fill: "#f5c400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.9 1.8L0 3l1.1-.35L0 1.45z",
    fill: "#1a2744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalNoteBadgeMemo);
export default __webpack_public_path__ + "static/media/internal-note-badge-memo.660624cf16d026502c3e314f69aa2afb.svg";
export { ForwardRef as ReactComponent };